import { useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Newspaper } from "@phosphor-icons/react";
import { relativeTime } from "@/lib/time";

export default function NewsCard({ item, variant = "default", index = 0 }) {
  const isHero = variant === "hero";
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <Link
      to={item.slug ? `/news/${item.slug}` : `/article/${item.id}`}
      state={{ item }}
      className={`group block bg-white border border-slate-200 hover:border-slate-300 hover:shadow-md rounded-xl overflow-hidden transition-all fade-up relative ${
        isHero ? "md:col-span-2 md:row-span-2" : ""
      }`}
      style={{ animationDelay: `${index * 40}ms` }}
      data-testid="news-article-card"
    >
      <div className={`relative overflow-hidden ${isHero ? "aspect-[16/10]" : "aspect-[16/9]"} bg-slate-100`}>
        {!imgFailed && item.thumbnail ? (
          <img
            src={item.thumbnail}
            alt={item.title}
            loading="lazy"
            className="w-full h-full object-cover opacity-95 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-300"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100" data-testid="card-image-fallback">
            <Newspaper size={isHero ? 48 : 28} weight="duotone" className="text-blue-400 opacity-70" />
          </div>
        )}
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="text-[10px] tracking-wide px-2 py-1 bg-white/90 backdrop-blur text-slate-700 border border-slate-200 rounded font-medium capitalize">
            {item.category}
          </span>
        </div>
      </div>

      <div className={`p-5 ${isHero ? "md:p-7" : ""}`}>
        {item.published && (
          <div className="flex items-center gap-3 text-xs text-slate-400 uppercase tracking-wider mb-3">
            <span className="flex items-center gap-1">
              <Clock size={12} weight="bold" /> {relativeTime(item.published)}
            </span>
          </div>
        )}
        <h3
          className={`font-semibold leading-snug group-hover:text-blue-600 transition-colors text-slate-900 ${
            isHero ? "text-2xl md:text-3xl" : "text-base md:text-lg"
          }`}
        >
          {item.title}
        </h3>
        {item.summary && isHero && (
          <p className="text-sm text-slate-500 mt-3 line-clamp-3 leading-relaxed">{item.summary}</p>
        )}
      </div>
    </Link>
  );
}
